

export const GLOBAL_URIS = {
    personalizationsHelp: 'https://help.agilitypr.com/en/articles/11196815-how-to-personalize-your-email-distributions-in-agility',
};
